import React from 'react';

function InscriptionsList({ 
  inscriptions, 
  statusLabels, 
  onSelect, 
  onValidate, 
  onReject, 
  onDelete,
  apiUrl 
}) {
  if (!inscriptions || inscriptions.length === 0) {
    return (
      <div className="empty-state">
        <div className="emoji">📭</div>
        <h3>لا توجد تسجيلات</h3>
        <p>لم يتم العثور على أي تسجيلات بعد</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>الاسم الكامل</th>
            <th>النوع</th>
            <th>المستوى</th>
            <th>الهاتف</th>
            <th>الحالة</th>
            <th>الصور</th>
            <th>التاريخ</th>
            <th>الإجراءات</th>
          </tr>
        </thead>
        <tbody>
          {inscriptions.map((inscription) => (
            <tr key={inscription._id}>
              <td>
                <strong>{inscription.nomComplet || '-'}</strong>
                {!inscription.isRead && inscription.statut === 'virement_en_attente' && (
                  <span style={{ 
                    marginRight: '8px', 
                    color: '#e94560',
                    fontSize: '0.8rem'
                  }}>
                    🔴 جديد
                  </span>
                )}
              </td>
              <td>
                {inscription.typeInscription ? (
                  <span className={`type-badge type-${inscription.typeInscription}`} style={{
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '0.85em',
                    fontWeight: '500',
                    display: 'inline-block',
                    backgroundColor: inscription.typeInscription === 'moaskar' ? '#fff3e0' : '#e3f2fd',
                    color: inscription.typeInscription === 'moaskar' ? '#e65100' : '#1976d2'
                  }}>
                    {inscription.typeInscription === 'moaskar' ? '🔥 معسكر' : '📚 عرض أساسي'}
                  </span>
                ) : '-'}
                {inscription.matieres && inscription.matieres.length > 0 && (
                  <div style={{ fontSize: '0.75em', color: '#666', marginTop: '4px' }}>
                    {inscription.matieres.length} مادة
                  </div>
                )}
              </td>
              <td>
                {inscription.niveauScolaire ? (
                  <span className={`niveau-badge niveau-${inscription.niveauScolaire}`}>
                    {inscription.niveauScolaire}
                  </span>
                ) : '-'}
              </td>
              <td>{inscription.telephone || '-'}</td>
              <td>
                <span className={`status-badge status-${inscription.statut}`}>
                  {statusLabels[inscription.statut] || inscription.statut}
                </span>
              </td>
              <td>
                <div className="image-links">
                  {inscription.screenshotVirement?.filepath && (
                    <a 
                      href={`${apiUrl}/inscriptions/${inscription._id}/screenshot-virement`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image-link"
                    >
                      💳 وصل
                    </a>
                  )}
                  {inscription.photoFacebook?.filepath && (
                    <a 
                      href={`${apiUrl}/inscriptions/${inscription._id}/photo-facebook`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image-link"
                    >
                      📘 فيسبوك
                    </a>
                  )}
                  {inscription.imagesTemporaires?.length > 0 && (
                    <span className="image-link">
                      📷 {inscription.imagesTemporaires.length}
                    </span>
                  )}
                </div>
              </td>
              <td>
                {new Date(inscription.createdAt).toLocaleDateString('ar-MA', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                })}
              </td>
              <td>
                <div className="actions-cell">
                  <button 
                    className="btn btn-secondary btn-sm"
                    onClick={() => onSelect(inscription)}
                  >
                    👁 عرض
                  </button>
                  <button 
                    className="btn btn-danger btn-sm"
                    onClick={() => {
                      if (window.confirm('هل أنت متأكد من حذف هذا التسجيل والمحادثة بالكامل؟')) {
                        onDelete(inscription._id);
                      }
                    }}
                    title="حذف التسجيل والمحادثة"
                  >
                    🗑
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default InscriptionsList;
